import { communityCardClickHandler, defaultSwiperOptions, getUnitType, toggleEl } from '../modules/utilities';
import { closeQuickAction, handleOtherActions } from './other-actions';
import { handleSaveEvent } from './save-community';
import { initQuickViewModal } from './quick-view';

export const rerenderCommunityList = (section, communities = [], withActions = true) => {
  if (section) {
    section.innerHTML = '';
    communities.forEach((community) => {
      const address = community.CommunityAddress;
      const divItem = document.createElement('div');
      divItem.classList.add('item');
      divItem.dataset.id = community.CommunityId;
      if (community.CommunitySpecial) {
        divItem.innerHTML = `
          <div class="move-in-special">
            <svg class="price-tag-icon"><use xlink:href="#price-tag"></use></svg>
            <span>Move-in Special</span>
          </div>
        `;
      }
      divItem.innerHTML += `
        <div class="images-wrapper">
          <a class="apt-fav ${community.IsSaved ? 'saved' : ''}" data-id="${community.CommunityId}" href="#save">
            <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
          </a>
          <div class="community-list-swiper swiper-custom">
            <div class="swiper-wrapper">
              ${(community.CommunityImages && community.CommunityImages.length) ? `
                ${community.CommunityImages.map((item => {
                  return `
                    <div class="swiper-slide">
                      <img src='${item.Image.Src}' alt='${item.Description}'/>
                    </div>
                  `;
                    })).join('')}
              ` : ''}
            </div>
            <div class="swiper-pagination swiper-pagination-custom"></div>
          </div>
        </div>
        <div class="community-details">
          <a href="${community.CommunityPageUrl}" class="property-types link">
            ${(community.CommunityUnitTypes && community.CommunityUnitTypes.length) ? `
              ${community.CommunityUnitTypes.map(unit => {
                return `<span>${getUnitType(unit)}</span>`
              }).join('')}
            ` : ''}
          </a>
          <p class="price-range">
            <sup>$</sup>
            <a>${community.CommunityMinPrice} – ${community.CommunityMaxPrice}</a>
          </p>
        </div>
        <p class="community-neighborhood">
          ${community.CommunityNeighborhood && community.CommunityNeighborhood != 'null' ? community.CommunityNeighborhood : ''}
        </p>
        <p class="community-name">
          ${community.CommunityName}
        </p>
        ${withActions ? `
          <div class="community-actions">
           <a class="button-link open-quick-view-modal" data-id="${community.CommunityId}">Quick View</a>
           <a href="${community.ScheduleTourUrl}" class="button-link">Tour Options</a>
           <div class="other other-maa" id="open-quick-actions">
              <svg class="other-actions"><use xlink:href="#other-actions"></use></svg>
              <div class="other-actions-dropdown other-actions-dropdown-maa">
                <div class="other-actions-dropdown__header">
                  <a href="#close"><svg class="close"><use xlink:href="#close"></use></svg></a>
                </div>
                <div class="community-quick-action" id="quick-action">
                  <div class="community-quick-action-address">
                    <p>${community.CommunityAddress}</p>
                  </div>
                  <a id="quick-action-add-to-compare" title="Add to compare" class="${community.IsInComparison ? 'compared' : ''}" data-id="${community.CommunityId}" href="#compare">
                    <span class="plus-icon"></span>
                    <p class="add-to-compare">Add to compare</p>
                    <p class="remove-from-compare">Remove from compare</p>
                  </a>
                  <a href="#" class="open-quick-view-modal" data-lat="${community.CommunityCoordinate.Lat}" data-lon="${community.CommunityCoordinate.Lon}" data-id="${community.CommunityId}" title="View on Map"><span class="map-pin-icon" /></span> View on Map</a>
                  <a id="quick-action-copy-address" data-value="${address}" title="Copy Address"><span class="copy-icon" /></span> Copy Address</a>
                  <a href="callto:${community.CommunityPhoneNumber}" title="Call Us"><span class="phone-icon" /></span> Call Us</a>
                </div>
              </div>
            </div>
          </div>
        ` : ''}

      `;

      const closeQuickActionIcon = divItem.querySelector('.other-actions-dropdown__header [href="#close"]');
      if (closeQuickActionIcon) {
        closeQuickActionIcon.addEventListener('click', (e) => {
          closeQuickAction(e);
        });
      }

      divItem.querySelector('.apt-fav')
        .addEventListener('click', (e) => {
          handleSaveEvent(e);
        });
      divItem.addEventListener('click', communityCardClickHandler);
      const quickAction = divItem.querySelector("#open-quick-actions");
      if (quickAction) {
        quickAction.addEventListener("click", toggleEl);
        quickAction.addEventListener("click", handleOtherActions);
      }
      divItem.querySelectorAll(".open-quick-view-modal")
        .forEach((quickViewBtn) => {
          quickViewBtn.addEventListener("click", (e) => {
            e.preventDefault();
            const { id } = e.currentTarget.dataset;
            if (id) {
              initQuickViewModal(id);
            }
          });
        });
      section.appendChild(divItem);
    });
    if (Swiper) {
      const swiperOptions = Object.assign({}, defaultSwiperOptions);
      new Swiper('.community-list-swiper', swiperOptions);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/render-communites.js